<template>
  <div>
    <Card shadow>
      <Tabs v-model="checkName">
        <TabPane label="查询玩家限制信息" name="1">
          <Form
            :ref="limit.form.ref"
            :model="limit.params"
            :rules="limit.form.rules"
            label-position="top"
          >
            <Row :gutter="20">
              <Col span="7" style="display:none">
                <FormItem prop="platid">
                  <label style="display: flex; align-items: center">
                    <span style="width: 80px">代理组:</span>
                    <Select
                      v-model="limit.params.platid"
                      filterable
                      placeholder="选择APP分组"
                      clearable
                    >
                      <Option
                        v-for="(item, index) in plat_list"
                        :value="item.id"
                        :label="item.name"
                        :key="index"
                      >
                        {{ item.name }}
                        <span style="color: #bbb">({{ item.id }})</span>
                      </Option>
                    </Select>
                  </label>
                </FormItem>
              </Col>
              <Col span="5">
                <FormItem prop="app_id">
                  <label style="display: flex; align-items: center">
                    <span style="width: 50px">代理:</span>
                    <Select
                      placeholder="请选择APP"
                      v-model="limit.params.app_id"
                      clearable
                      filterable
                    >
                      <Option
                        v-for="(item, index) in app_list"
                        :value="item.appid"
                        :label="item.appName"
                        :key="index"
                      >
                        {{ item.appName }}
                        <span style="color: #bbb">({{ item.appid }})</span>
                      </Option>
                    </Select>
                  </label>
                </FormItem>
              </Col>
              <Col span="5">
                <FormItem prop="t">
                  <label style="display: flex; align-items: center">
                    <span style="width: 120px">查询类型:</span>
                    <Select
                      placeholder="查询类型"
                      v-model="limit.params.t"
                      clearable
                      filterable
                    >
                      <Option
                        v-for="item in limit.type_list"
                        :value="item.value"
                        :key="item.value"
                        :label="item.name"
                        >{{ item.name }}</Option
                      >
                    </Select>
                  </label>
                </FormItem>
              </Col>
              <Col span="5">
                <FormItem prop="uid">
                  <label style="display: flex; align-items: center">
                    <span style="width: 140px">用户ID:</span>
                    <Input
                      placeholder="用户ID"
                      v-model.trim="limit.params.uid"
                      style="width: 100%"
                    />
                  </label>
                </FormItem>
              </Col>
              <Col span="3">
                <FormItem>
                  <Button
                    type="primary"
                    @click="searchSmartList"
                    icon="md-refresh"
                    >查询</Button
                  >
                </FormItem>
              </Col>
            </Row>
          </Form>
          <div>
            <Card v-if="limit.total" :bordered="false">
              <p slot="title">总共{{ limit.total }}个</p>
              <p>{{ limit.data }}</p>
            </Card>
          </div>
        </TabPane>
        <TabPane label="白名单" name="2">
          <Form
            :ref="white.form.ref"
            :model="white.params"
            :rules="white.form.rules"
            label-position="top"
          >
            <Row :gutter="20">
              <Col span="5">
                <FormItem prop="platid">
                  <Select
                    v-model="white.params.platid"
                    filterable
                    placeholder="选择APP分组"
                    clearable
                  >
                    <Option
                      v-for="(item, index) in plat_list"
                      :value="item.id"
                      :label="item.name"
                      :key="index"
                    >
                      {{ item.name }}
                      <span style="color: #bbb">({{ item.id }})</span>
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="5">
                <FormItem prop="app_id">
                  <Select
                    placeholder="请选择APP"
                    v-model="white.params.app_id"
                    clearable
                    filterable
                  >
                    <Option
                      v-for="item in select.whiteapp_list.filter(
                        item => item.platform == white.params.platid
                      )"
                      :value="item.value"
                      :key="item.value"
                      :label="item.name"
                    >
                      {{ item.name }}
                      <span style="color: #bbb">（{{ item.value }}）</span>
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="10">
                <FormItem>
                  <Button
                    type="primary"
                    @click="getGameRiskWhites()"
                    :disabled="
                      white.params.platid < 0 ||
                        white.params.app_id < 0 ||
                        white.params.app_id == 'underfind' ||
                        white.params.platid == 'underfind'
                    "
                    icon="md-refresh"
                    style="margin-right: 18px"
                    >查询</Button
                  >
                  <Button
                    type="primary"
                    @click="addWhite"
                    :disabled="
                      white.params.platid < 0 ||
                        white.params.app_id < 0 ||
                        white.params.app_id == 'underfind' ||
                        white.params.platid == 'underfind'
                    "
                    >添加白名单</Button
                  >
                </FormItem>
              </Col>
            </Row>
          </Form>
          <Table
            border
            :columns="white.columns"
            :data="white.data"
            style="margin-top: 12px"
          />
        </TabPane>
        <TabPane label="黑名单" name="3">
          <Form
            :ref="black.form.ref"
            :model="black.params"
            :rules="black.form.rules"
            label-position="top"
          >
            <Row :gutter="20">
              <Col span="5">
                <FormItem prop="platid">
                  <Select
                    v-model="black.params.platid"
                    filterable
                    placeholder="选择APP分组"
                    clearable
                  >
                    <Option
                      v-for="(item, index) in plat_list"
                      :value="item.id"
                      :label="item.name"
                      :key="index"
                    >
                      {{ item.name }}
                      <span style="color: #bbb">({{ item.id }})</span>
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="5">
                <FormItem prop="app_id">
                  <Select
                    placeholder="请选择APP"
                    v-model="black.params.app_id"
                    clearable
                    filterable
                  >
                    <Option
                      v-for="item in select.whiteapp_list.filter(
                        item => item.platform == black.params.platid
                      )"
                      :value="item.value"
                      :key="item.value"
                      :label="item.name"
                    >
                      {{ item.name }}
                      <span style="color: #bbb">（{{ item.value }}）</span>
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="6">
                <FormItem>
                  <Button
                    type="primary"
                    @click="getGameRiskBlackIps"
                    :disabled="
                      black.params.platid < 0 ||
                        black.params.app_id < 0 ||
                        black.params.app_id == 'underfind' ||
                        black.params.platid == 'underfind'
                    "
                    icon="md-refresh"
                    style="margin-right: 18px"
                    >查询</Button
                  >
                  <Button
                    type="primary"
                    @click="OpenModal7"
                    :disabled="
                      black.params.platid < 0 ||
                        black.params.app_id < 0 ||
                        black.params.app_id == 'underfind' ||
                        black.params.platid == 'underfind'
                    "
                    >添加黑名单</Button
                  >
                </FormItem>
              </Col>
            </Row>
          </Form>
          <Table
            border
            :columns="black.columns"
            :data="black.data"
            style="margin-top: 12px"
          />
        </TabPane>
      </Tabs>
    </Card>
    <!-- 添加黑名单 -->
    <Modal v-model="modal7.show" @on-cancel="CloseModal7" width="650">
      <div slot="header">玩家黑名单</div>
      <Form :model="modal7.params" :label-width="120">
        <Row>
          <Col span="20">
            <FormItem label="IP">
              <Input
                type="text"
                v-model="modal7.params.ip"
                style="width: 100%"
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="描述信息">
              <Input
                type="textarea"
                v-model="modal7.params.desc"
                style="width: 100%"
              />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="updateGameRiskBlackIp()">提交</Button>
      </div>
    </Modal>
    <!-- 添加白名单 -->
    <Modal v-model="modal4.show" @on-cancel="CloseModal4" width="650">
      <div slot="header">玩家白名单</div>
      <Form
        :ref="modal4.form.ref"
        :model="modal4.params"
        :rules="modal4.form.rules"
        :label-width="120"
      >
        <Row>
          <Col span="20">
            <FormItem label="用户UID" prop="uid">
              <InputNumber
                type="text"
                v-model="modal4.params.uid"
                style="width: 100%"
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="白名单类型">
              <RadioGroup v-model="modal4.params.type">
                <Radio :label="0">不执行智能风控</Radio>
                <Radio :label="1">不执行IP限制</Radio>
                <Radio :label="2">不执行Mac限制</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="updateGameRiskWhite">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import MulReportHeader from '../Report/components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import publicTable from '@/views/components/publicTable.vue'
export default {
  name: 'PlayerIPLimit',
  components: {
    MulReportHeader,
    publicTable
  },
  data() {
    return {
      checkName: '1',
      limit: {
        type_list: [
          { value: 1, name: 'IP限制' },
          { value: 2, name: 'Mac限制' }
        ],
        form: {
          ref: 'modal5_form',
          rules: {
            uid: [
              {
                required: true,
                trigger: 'blur',
                validator: this.simpleVerify('请输入用户ID')
              }
            ],
            t: [
              {
                required: true,
                trigger: 'change',
                validator: this.simpleVerify('请选择类型')
              }
            ],
            ...this.getAppPlatRule()
          }
        },
        params: {
          platid: Number(localStorage.getItem('platId')),
          app_id: -1,
          t: 0,
          uid: ''
        },
        total: 0,
        data: ''
      },
      white: {
        form: { ref: 'white_form', rules: this.getAppPlatRule() },
        params: { platid: -1, app_id: -1 },
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          {
            title: '所属盘口',
            key: 'app_id',
            minWidth: 90,
            align: 'center',
            render: (h, params) => {
              let arr = []
              let app_info = this.select.app_list.filter(
                v => v.value == params.row.app_id
              )[0]
              if (app_info) {
                arr.push(
                  h('span', app_info.name),
                  h('span', { style: 'color:#bbb' }, `（${app_info.value}）`)
                )
              } else {
                arr.push(h('span', { style: 'color:#ed4014' }, `未找到指定App`))
              }
              return h('div', arr)
            }
          },
          { title: '玩家ID', key: 'uid', minWidth: 90, align: 'center' },
          {
            title: '白名单类型',
            key: 'type',
            minWidth: 120,
            align: 'center',
            render: (h, params) =>
              h(
                'div',
                {
                  style: `color:${
                    ['#ed4014', '#19be6b', 'red'][params.row.type]
                  }`
                },
                ['不执行智能风控', '不执行IP限制', '不执行Mac限制'][
                  params.row.type
                ]
              )
          },
          {
            title: '更新时间',
            key: 'update_time',
            minWidth: 90,
            align: 'center'
          },
          {
            title: '管理',
            key: 'id',
            minWidth: 90,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          content: `确认删除此条白名单记录`,
                          onOk: () => {
                            let param = this.getTransParams(
                              'UpdateGameRiskWhite',
                              {
                                platid: this.white.params.platid,
                                app_id: this.white.params.app_id,
                                id: params.row.id,
                                uid: params.row.uid
                              }
                            )
                            TransTopReq(param).then(res => {
                              this.getGameRiskWhites()
                            })
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      },
      modal7: {
        show: false,
        form: { rules: this.getAppPlatRule(), data: {}, ref: 'modal4_form' },
        params: { id: '', ip: '', desc: '' }
      },
      black: {
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          { title: 'IP地址', key: 'ip', minWidth: 90, align: 'center' },
          { title: '描述', key: 'desc', minWidth: 90, align: 'center' },
          { title: '时间', key: 'itime', minWidth: 90, align: 'center' },
          {
            title: '管理',
            key: 'id',
            minWidth: 90,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          content: `确认删除此条白名单记录`,
                          onOk: () => {
                            this.updateGameRiskBlackIp(params.row.id)
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        form: { ref: 'modal6_form', rules: this.getAppPlatRule() },
        params: { platid: -1, app_id: -1 }
      },
      modal4: {
        show: false,
        params: { id: '', uid: 0, type: 0, platid: -1, app_id: -1 },
        form: {
          data: {},
          ref: 'modal4_form',
          rules: {
            uid: [
              {
                required: true,
                trigger: 'blur',
                validator: this.simpleVerify('请输入 用户ID')
              }
            ]
          }
        }
      },
      select: {
        app_list: [],
        whiteapp_list: [],
        user_List: new Array(21)
      }
    }
  },
  methods: {
    getAppPlatRule() {
      return {
        app_id: [
          {
            required: true,
            trigger: 'change',
            validator: this.currentVerify('请选择所属APP')
          }
        ]
        // platid: [
        //   {
        //     required: true,
        //     trigger: 'change',
        //     validator: this.currentVerify('请选择所属APP')
        //   }
        // ]
      }
    },
    currentVerify(message) {
      return (rule, value, callback) => {
        if (value < 0 || value == undefined) {
          callback(new Error(message))
        } else {
          callback()
        }
      }
    },
    addWhite() {
      let result = { uid: null, id: '', type: 0 }
      this.modal4.params = result
      this.modal4.show = true
    },
    searchSmartList() {
      this.$refs[this.limit.form.ref].validate(valid => {
        if (valid) {
          this.querySmartRiskInfo()
        }
      })
    },
    getGameRiskWhites() {
      let params = this.getTransParams('GetGameRiskWhites', this.white.params)
      TransTopReq(params).then(res => {
        this.white.data = res._param.data || []
      })
    },
    updateGameRiskWhite() {
      this.$refs[this.modal4.form.ref].validate(valid => {
        if (valid) {
          let { platid, app_id } = this.white.params
          let params = this.getTransParams('UpdateGameRiskWhite', {
            ...this.modal4.params,
            platid,
            app_id
          })
          TransTopReq(params).then(res => {
            this.getGameRiskWhites()
            this.CloseModal4()
          })
        }
      })
    },
    updateGameRiskBlackIp(id) {
      if (id) {
        this.modal7.params.id = id
      }
      let { platid, app_id } = this.black.params
      let params = this.getTransParams('UpdateGameRiskBlackIp', {
        platid,
        app_id,
        ...this.modal7.params
      })
      TransTopReq(params).then(res => {
        this.getGameRiskBlackIps()
        this.CloseModal7()
      })
    },
    OpenModal4() {
      let result = { uid: null, id: '', type: 0 }
      this.modal4.params = result
      this.modal4.show = true
    },
    CloseModal4() {
      this.modal4.show = false
      this.$refs[this.modal4.form.ref].resetFields()
    },
    OpenModal7() {
      this.modal7.params = { id: '', ip: '', desc: '' }
      this.modal7.show = true
    },
    CloseModal7() {
      this.modal7.show = false
      this.$refs[this.modal7.form.ref].resetFields()
    },
    querySmartRiskInfo() {
      this.limit.params.uid= Number(this.limit.params.uid)
      let params = this.getTransParams('QuerySmartRiskInfo', this.limit.params)
      TransTopReq(params).then(res => {
        this.limit.data = res._param.data || []
        this.limit.total = res._param.total
      })
    },
    getGameRiskBlackIps() {
      let params = this.getTransParams('GetGameRiskBlackIps', this.black.params)
      TransTopReq(params).then(res => {
        this.black.data = res._param.data || []
      })
    },
    getTransParams(_func, params) {
      return {
        mod: 'root',
        platid: params.platid,
        app_id: params.app_id,
        param: {
          _mod: 'root',
          _func,
          _param: { ...params }
        }
      }
    },
    initFunc() {
      let result = []
      this.app_list.map(item => {
        result.push({
          value: item.appid || 0,
          name: item.appName,
          platform: item.platform
        })
      })
      this.select.app_list = result
      this.select.whiteapp_list = result.filter(item => item.value)
    }
  },

  created() {
    this.initFunc()
  }
}
</script>

<style scoped lang="less"></style>
